<template>
  <div class="form-container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>

    <div class="form-group-custom">
      <label
        >300 - 579 (Poor) – Clarify Details & Assign an Interest Rate</label
      >
      <HiloSelect
        id="poorPreApproval"
        :theme="'grey'"
        v-model="form.poorPreApprovalPermitted"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Pre-Approval Permitted...'"
      />
    </div>

    <div class="form-group-custom mt-top">
      <HiloSelect
        id="poorCoSigner"
        :theme="'grey'"
        v-model="form.poorCoSignerRequired"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Co-Signer Required...'"
      />
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <HiloSelect
          id="poorIncome"
          :theme="'grey'"
          v-model="form.poorIncomeRequired"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Income Required...'"
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.poorIncomeAmount"
          :disabled="form.poorIncomeRequired !== true"
          placeholder="Income Amount..."
        />
      </div>
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.poorBaseInterestRate"
          placeholder="Base Interest Rate..."
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.poorPeakInterestRate"
          placeholder="Peak Interest Rate..."
        />
      </div>
    </div>

    <div class="form-group-custom">
      <label
        >580 - 669 (Fair) – Clarify Details & Assign an Interest Rate</label
      >
      <HiloSelect
        id="fairPreApproval"
        :theme="'grey'"
        v-model="form.fairPreApprovalPermitted"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Pre-Approval Permitted...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom mt-top">
      <HiloSelect
        id="fairCoSigner"
        :theme="'grey'"
        v-model="form.fairCoSignerRequired"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Co-Signer Required...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <HiloSelect
          id="fairIncome"
          :theme="'grey'"
          v-model="form.fairIncomeRequired"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Income Required...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          :disabled="form.fairIncomeRequired !== true"
          v-model="form.fairIncomeAmount"
          placeholder="Income Amount..."
        />
      </div>
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.fairBaseInterestRate"
          placeholder="Base Interest Rate..."
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.fairPeakInterestRate"
          placeholder="Peak Interest Rate..."
        />
      </div>
    </div>

    <div class="form-group-custom">
      <label
        >670 - 739 (Good) – Clarify Details & Assign an Interest Rate</label
      >
      <HiloSelect
        id="goodPreApproval"
        :theme="'grey'"
        v-model="form.goodPreApprovalPermitted"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Pre-Approval Permitted...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom mt-top">
      <HiloSelect
        id="goodCoSigner"
        :theme="'grey'"
        v-model="form.goodCoSignerRequired"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Co-Signer Required...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <HiloSelect
          id="goodIncome"
          :theme="'grey'"
          v-model="form.goodIncomeRequired"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Income Required...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          :disabled="form.goodIncomeRequired !== true"
          v-model="form.goodIncomeAmount"
          placeholder="Income Amount..."
        />
      </div>
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.goodBaseInterestRate"
          placeholder="Base Interest Rate..."
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.goodPeakInterestRate"
          placeholder="Peak Interest Rate..."
        />
      </div>
    </div>

    <div class="form-group-custom">
      <label
        >740 - 799 (Very Good) – Clarify Details & Assign an Interest
        Rate</label
      >
      <HiloSelect
        id="veryGoodPreApproval"
        :theme="'grey'"
        v-model="form.veryGoodPreApprovalPermitted"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Pre-Approval Permitted...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom mt-top">
      <HiloSelect
        id="veryGoodCoSigner"
        :theme="'grey'"
        v-model="form.veryGoodCoSignerRequired"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Co-Signer Required...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <HiloSelect
          id="veryGoodIncome"
          :theme="'grey'"
          v-model="form.veryGoodIncomeRequired"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Income Required...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          :disabled="form.veryGoodIncomeRequired !== true"
          v-model="form.veryGoodIncomeAmount"
          placeholder="Income Amount..."
        />
      </div>
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.veryGoodBaseInterestRate"
          placeholder="Base Interest Rate..."
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.veryGoodPeakInterestRate"
          placeholder="Peak Interest Rate..."
        />
      </div>
    </div>

    <div class="form-group-custom">
      <label
        >800 - 850 (Excellent) – Clarify Details & Assign an Interest
        Rate</label
      >
      <HiloSelect
        id="excellentPreApproval"
        :theme="'grey'"
        v-model="form.excellentPreApprovalPermitted"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Pre-Approval Permitted...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom mt-top">
      <HiloSelect
        id="excellentCoSigner"
        :theme="'grey'"
        v-model="form.excellentCoSignerRequired"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Co-Signer Required...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <HiloSelect
          id="excellentIncome"
          :theme="'grey'"
          v-model="form.excellentIncomeRequired"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Income Required...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          :disabled="form.excellentIncomeRequired !== true"
          v-model="form.excellentIncomeAmount"
          placeholder="Income Amount..."
        />
      </div>
    </div>

    <div class="flex-row sm-gap mt-top" :style="$global.dynamicCols(2)">
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.excellentBaseInterestRate"
          placeholder="Base Interest Rate..."
        />
      </div>
      <div class="form-group-custom">
        <input
          type="number"
          v-model="form.excellentPeakInterestRate"
          placeholder="Peak Interest Rate..."
        />
      </div>
    </div>

    <div class="form-group-custom">
      <label>Origination Fee Amount</label>
      <input
        type="number"
        v-model="form.originationFeeAmount"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label>Repayment Options</label>
      <HiloSelect
        id="repaymentOptions"
        :theme="'grey'"
        multi-select
        v-model="form.repaymentOptions"
        :options="repaymentOptionsList"
        :placeholder="'Select all that apply...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Eligibility for International Students?</label>
      <HiloSelect
        id="internationalStudentEligibility"
        :theme="'grey'"
        v-model="form.internationalStudentEligibilityId"
        :options="internationalStudentEligibilityList"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Loan Usage Restrictions</label>
      <HiloSelect
        id="loanUsageRestrictions"
        :theme="'grey'"
        multi-select
        v-model="form.loanUsageRestrictions"
        :options="loanUsageRestrictionsList"
        :placeholder="'Select all that apply...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Penalty for Early Repayment?</label>
      <HiloSelect
        id="penaltyEarly"
        :theme="'grey'"
        v-model="form.penaltyEarlyRepayment"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Loan Processing Time?</label>
      <input
        type="text"
        v-model="form.loanProcessingTime"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label
        >Do you offer pre-qualification checks without a hard credit
        pull?</label
      >
      <HiloSelect
        id="preQualification"
        :theme="'grey'"
        v-model="form.preQualification"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="buttonContainer">
      <div class="nextButton" @click="handleNext">
        <b class="name">Next</b>
      </div>
      <div class="backButton" @click="$emit('onPrev')">
        <b class="name">Back</b>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import get from "lodash/get";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();

export default defineComponent({
  components: { HiloSelect },
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    lenderId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        poorPreApprovalPermitted: "",
        poorCoSignerRequired: "",
        poorIncomeRequired: "",
        poorIncomeAmount: "",
        poorBaseInterestRate: "",
        poorPeakInterestRate: "",
        fairPreApprovalPermitted: "",
        fairCoSignerRequired: "",
        fairIncomeRequired: "",
        fairIncomeAmount: "",
        fairBaseInterestRate: "",
        fairPeakInterestRate: "",
        goodPreApprovalPermitted: "",
        goodCoSignerRequired: "",
        goodIncomeRequired: "",
        goodIncomeAmount: "",
        goodBaseInterestRate: "",
        goodPeakInterestRate: "",
        veryGoodPreApprovalPermitted: "",
        veryGoodCoSignerRequired: "",
        veryGoodIncomeRequired: "",
        veryGoodIncomeAmount: "",
        veryGoodBaseInterestRate: "",
        veryGoodPeakInterestRate: "",
        excellentPreApprovalPermitted: "",
        excellentCoSignerRequired: "",
        excellentIncomeRequired: "",
        excellentIncomeAmount: "",
        excellentBaseInterestRate: "",
        excellentPeakInterestRate: "",
        originationFeeAmount: "",
        repaymentOptions: [],
        internationalStudentEligibilityId: "",
        loanUsageRestrictions: [],
        penaltyEarlyRepayment: "",
        loanProcessingTime: "",
        preQualification: "",
      },
      repaymentOptionsList: [],
      internationalStudentEligibilityList: [],
      loanUsageRestrictionsList: [],
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getAboutYouLists();
      await this.getStudentCriteriaSavedData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.repaymentOptionsList,
          this.internationalStudentEligibilityList,
          this.loanUsageRestrictionsList,
        ] = await Promise.all([
          aboutYouAPIService.getRepaymentOptionsList(),
          aboutYouAPIService.getInternationalStudentEligibilityList(),
          aboutYouAPIService.getLoanUsageRestrictionsList(),
        ]);
      } catch (error) {}
    },
    async getStudentCriteriaSavedData() {
      if (this.lenderId) {
        try {
          const fetchedData = await aboutYouAPIService.getLenderById(
            this.lenderId,
          );
          if (fetchedData) {
            this.form = { ...this.form, ...fetchedData };
          }
        } catch (error) {}
      }
    },
    async handleNext() {
      const validations = [
        {
          field: "poorPreApprovalPermitted",
          desc: "Poor Pre-Approval Permitted",
        },
        { field: "poorCoSignerRequired", desc: "Poor Co-Signer Requirement" },
        {
          field: "poorIncomeRequired",
          desc: "Poor Income Requirement",
          type: "income",
        },
        {
          field: "poorIncomeAmount",
          desc: "Poor Income Amount",
          type: "amount",
        },
        { field: "poorBaseInterestRate", desc: "Poor Base Interest Rate" },
        { field: "poorPeakInterestRate", desc: "Poor Peak Interest Rate" },
        {
          field: "fairPreApprovalPermitted",
          desc: "Fair Pre-Approval Permitted",
        },
        { field: "fairCoSignerRequired", desc: "Fair Co-Signer Requirement" },
        {
          field: "fairIncomeRequired",
          desc: "Fair Income Requirement",
          type: "income",
        },
        {
          field: "fairIncomeAmount",
          desc: "Fair Income Amount",
          type: "amount",
        },
        { field: "fairBaseInterestRate", desc: "Fair Base Interest Rate" },
        { field: "fairPeakInterestRate", desc: "Fair Peak Interest Rate" },
        {
          field: "goodPreApprovalPermitted",
          desc: "Good Pre-Approval Permitted",
        },
        { field: "goodCoSignerRequired", desc: "Good Co-Signer Requirement" },
        {
          field: "goodIncomeRequired",
          desc: "Good Income Requirement",
          type: "income",
        },
        {
          field: "goodIncomeAmount",
          desc: "Good Income Amount",
          type: "amount",
        },
        { field: "goodBaseInterestRate", desc: "Good Base Interest Rate" },
        { field: "goodPeakInterestRate", desc: "Good Peak Interest Rate" },
        {
          field: "veryGoodPreApprovalPermitted",
          desc: "Very Good Pre-Approval Permitted",
        },
        {
          field: "veryGoodCoSignerRequired",
          desc: "Very Good Co-Signer Requirement",
        },
        {
          field: "veryGoodIncomeRequired",
          desc: "Very Good Income Requirement",
          type: "income",
        },
        {
          field: "veryGoodIncomeAmount",
          desc: "Very Good Income Amount",
          type: "amount",
        },
        {
          field: "excellentPreApprovalPermitted",
          desc: "Excellent Pre-Approval Permitted",
        },
        {
          field: "excellentCoSignerRequired",
          desc: "Excellent Co-Signer Requirement",
        },
        {
          field: "excellentIncomeRequired",
          desc: "Excellent Income Requirement",
          type: "income",
        },
        {
          field: "excellentIncomeAmount",
          desc: "Excellent Income Amount",
          type: "amount",
        },
        {
          field: "excellentBaseInterestRate",
          desc: "Excellent Base Interest Rate",
        },
        {
          field: "excellentPeakInterestRate",
          desc: "Excellent Peak Interest Rate",
        },
        { field: "originationFeeAmount", desc: "Origination Fee Amount" },
        { field: "repaymentOptions", desc: "Repayment Options" },
        {
          field: "internationalStudentEligibilityId",
          desc: "International Student Eligibility",
        },
        { field: "loanUsageRestrictions", desc: "Loan Usage Restrictions" },
        { field: "penaltyEarlyRepayment", desc: "Penalty for Early Repayment" },
        { field: "loanProcessingTime", desc: "Loan Processing Time" },
        { field: "preQualification", desc: "Pre-Qualification Check" },
      ];

      let missingFields = [];

      for (const { field, desc, type } of validations) {
        const fieldValue = get(this.form, field);

        if (type === "income" && fieldValue === false) {
          continue;
        }

        if (type === "amount") {
          const requiredField = field.replace("Amount", "Required");
          const requiredFieldValue = get(this.form, requiredField);

          if (requiredFieldValue === false) {
            continue;
          }
        }

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          missingFields.push(desc);
        }
      }

      if (missingFields.length > 0) {
        alert(
          `Please enter the following required fields:\n- ${missingFields.join("\n- ")}`,
        );
        return;
      }

      try {
        this.loading = true;
        const studentCriteriaData = {
          ...this.form,
          lenderId: this.lenderId,
          userId: this.userId,
        };
        await aboutYouAPIService.createOrUpdateLender(studentCriteriaData);
        this.$emit("onNext", { studentCriteria: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.mt-top {
  margin-top: -10px;
}
</style>
